/** English text for the customer account area. Each value is also its translation key. */
export const A = {
  visitStore: 'Visit the storefront',
  broadcasting: 'Broadcasting from beyond',
  navOverview: 'Overview',
  navOrders: 'Orders',
  navReceipts: 'Receipts',
  navTickets: 'Tickets',
  navSupport: 'Support',
  navReferrals: 'Referrals',
  navPrefs: 'Preferences',
  navVerifier: 'IPTV Verifier',
  theme: 'Theme',
  team: 'Team',
  storefront: 'Storefront',
  myDetails: 'My details',
  changePw: 'Change password',
  signOut: 'Sign out',
  customer: 'Customer',

  dropped: 'The signal dropped.',
  wrong: 'Something went wrong while loading.',
  tryAgain: 'Try again',
  pageOf: 'Page {page} of {pages}',
  totalN: '{count} total',
  prev: 'Previous',
  next: 'Next',

  sPending: 'Pending',
  sInvoiced: 'Invoiced',
  sPaid: 'Paid',
  sActive: 'Active',
  sTrial: 'Trial',
  sExpired: 'Expired',
  sCancelled: 'Cancelled',
  sSuspended: 'Suspended',
  sOpen: 'Open',
  sAnswered: 'Answered',
  sClosed: 'Closed',

  loadOrders: 'Could not load your orders',
  loadTickets: 'Could not load your tickets',
  earned: 'You earned {count} referrals',
  friendLive: 'A friend you referred has their line live.',
  refsN: '{count} referrals',
  refsEarnedN: '{count} referrals earned',
  newTag: 'New',
  qVerH: 'Check your line is genuine Ghost Cable',
  qHelp: 'Get help',
  qHelpH: 'Open a support ticket',
  qRecH: 'Download PDF receipts',
  qRevH: 'Tell others how it went',
  qPrefH: 'Contact and email settings',
  qAppH: 'Add Ghost Cable to your home screen',
  copied: 'Copied',
  cantCopy: 'Could not copy. Select the code and copy it by hand.',
  welcomeName: 'Welcome back, {name}',
  overviewDesc: 'Your lines, renewals and support in one place.',
  newOrder: 'New order',
  mLive: 'Live lines',
  mLiveH: 'Active or on trial',
  mWait: 'Waiting',
  mWaitH: 'Pending or invoiced',
  mOpen: 'Open tickets',
  mOpenH: 'Open or answered',
  mAllH: 'All time',
  endingSoon: 'Ending soon',
  nothingEnding: 'Nothing is close to ending',
  showDays: 'Lines show up here {days} days before their term ends.',
  ended: 'Ended',
  minLeft: '{count} min left',
  hoursLeft: '{count} hours left',
  daysLeft: '{count} days left',
  endsOn: 'ends {date}',
  recent: 'Recent orders',
  allOrders: 'All orders',
  noOrders: 'No orders yet',
  noOrdersP: 'Pick a plan and we will send payment instructions by email.',
  startOrder: 'Start an order',
  refer: 'Refer a friend',
  shareLink: 'Share your link. Each friend who buys {months} months or longer earns you a free month.',
  shareCode: 'Share your code. Friends mention it when they order.',
  sharePic: 'Get your share picture',
  alsoWorks: 'Also works',
  yourUsername: 'Your username',
  orCode: 'Or your code',
  refEarnedLbl: 'Referrals earned',
  refFriends: 'Friends who bought {months}+ months with your username or code.',
  refGoesUp: 'Goes up when a friend buys {months} months or longer and their line goes live.',
  plusNew: '+{count} new',
  freeMonths: '{count} free months on the way to your line',
  onceActive: 'Once your line is active and paid, your username works as your referral code.',
  howRef: 'How referrals work',
  shortcuts: 'Shortcuts',

  renewReq: 'Renewal requested {when}',
  renewDone: "Renewal requested. We'll email your invoice shortly.",
  requesting: 'Requesting…',
  keepLine: 'Keep this line',
  reqRenew: 'Request renewal',

  linkCopied: 'Link copied',
  cantCopyLink: 'Could not copy. Select the link and copy it by hand.',
  yourLink: 'Your referral link',
  usernameOn: 'Username on it:',
  fromFirst: '(from your first line)',
  notActive:
    'This line isn’t active right now. Friends can still open the link, but it only earns you free months while the line is active and paid.',
  copyLink: 'Copy link',
  share: 'Share',
};
